// src/components/QuestionReviewer.js

import React, { useState, useEffect } from 'react';

// Bileşene özel stiller
const styles = {
    container: { fontFamily: 'sans-serif', padding: '20px' },
    questionCard: { border: '1px solid #ccc', borderRadius: '8px', padding: '15px', marginBottom: '20px', backgroundColor: '#f9f9f9' },
    questionTextarea: { width: '100%', minHeight: '80px', padding: '8px', marginBottom: '10px', boxSizing: 'border-box' },
    optionsContainer: { display: 'flex', flexDirection: 'column', gap: '10px' },
    optionWrapper: { display: 'flex', alignItems: 'center', gap: '10px' },
    optionInput: { flex: 1, padding: '8px' },
    correctAnswerRadio: { width: '20px', height: '20px' },
    saveButton: { padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px' }
};

const QuestionReviewer = ({ questions, onSave, isSaving }) => {
    // Gelen soruları düzenlenebilir hale getirmek için kendi state'imize kopyalıyoruz.
    const [editableQuestions, setEditableQuestions] = useState([]);

    // Ana bileşenden yeni sorular geldiğinde state'imizi güncelliyoruz.
    useEffect(() => {
        // Gelen veriye güvenli bir şekilde erişmek için kontrol
        if (questions && Array.isArray(questions)) {
            setEditableQuestions(questions);
        }
    }, [questions]);

    // Soru metni değiştiğinde çalışacak fonksiyon
    const handleQuestionTextChange = (questionIndex, newText) => {
        const updatedQuestions = [...editableQuestions];
        updatedQuestions[questionIndex].questionText = newText;
        setEditableQuestions(updatedQuestions);
    };

    // Seçenek metni değiştiğinde çalışacak fonksiyon
    const handleOptionTextChange = (questionIndex, optionKey, newText) => {
        const updatedQuestions = [...editableQuestions];
        updatedQuestions[questionIndex].options[optionKey] = newText;
        setEditableQuestions(updatedQuestions);
    };

    // Doğru cevap seçimi değiştiğinde çalışacak fonksiyon
    const handleCorrectAnswerChange = (questionIndex, newCorrectOptionKey) => {
        const updatedQuestions = [...editableQuestions];
        updatedQuestions[questionIndex].correctAnswer = newCorrectOptionKey;
        setEditableQuestions(updatedQuestions);
    };

    // Eğer hiç soru yoksa bir mesaj gösterelim.
    if (!editableQuestions || editableQuestions.length === 0) {
        return <div style={styles.container}><p>Henüz işlenmiş bir soru bulunmuyor. Lütfen bir PDF yükleyin.</p></div>;
    }

    return (
        <div style={styles.container}>
            <h2>Soruları Kontrol Et ve Kaydet</h2>
            <p>Yapay zeka tarafından çekilen verileri aşağıda kontrol edebilir, hataları düzeltebilir ve sonrasında veritabanına kaydedebilirsiniz.</p>
            
            {/* Soruları map ile dönerek her biri için bir düzenleme kartı oluşturuyoruz */}
            {editableQuestions.map((q, index) => (
                <div key={q.questionNumber || index} style={styles.questionCard}>
                    <h4>Soru {q.questionNumber}</h4>
                    <textarea
                        style={styles.questionTextarea}
                        value={q.questionText}
                        onChange={(e) => handleQuestionTextChange(index, e.target.value)}
                    />
                    <div style={styles.optionsContainer}>
                        {Object.entries(q.options).map(([key, value]) => (
                            <div key={key} style={styles.optionWrapper}>
                                <input
                                    type="radio"
                                    name={`correct-answer-${index}`}
                                    style={styles.correctAnswerRadio}
                                    checked={q.correctAnswer === key}
                                    onChange={() => handleCorrectAnswerChange(index, key)}
                                    title="Doğru cevap olarak işaretle"
                                />
                                <label>{key})</label>
                                <input
                                    type="text"
                                    style={styles.optionInput}
                                    value={value}
                                    onChange={(e) => handleOptionTextChange(index, key, e.target.value)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
            
            <button 
                style={styles.saveButton}
                onClick={() => onSave(editableQuestions)}
                disabled={isSaving}
            >
                {isSaving ? 'Kaydediliyor...' : 'Tüm Soruları Veritabanına Kaydet'}
            </button>
        </div>
    );
};

export default QuestionReviewer;